module.exports = __webpack_public_path__ + "img/socialapp.e7a69a42.jpg";